import { render } from "./factures_history_list_page.vue?vue&type=template&id=2bf88b5a"
import script from "./factures_history_list_page.vue?vue&type=script&lang=js"
export * from "./factures_history_list_page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__